<template>
  <router-link :to="url || '/pontoDeInteresse/' + interestPoint.id" class="interest-point-item">
    <div class="zoomable-image image"><img :src="calendarItem.images[0] && calendarItem.images[0].image_url"></div>
    <h2 class="title" v-if="calendarItem.translation">{{calendarItem.translation.name}}</h2>
    <p class="description" v-if="calendarItem.translation">{{calendarItem.translation.type}}</p>
  </router-link>
</template>
<script>

export default {
  name: 'calendarItemItem',
  props: ['url', 'calendarItem'],
  components: {
  },
  data() {
    return {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.image {
  width: 100%;
}
</style>